import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

/** Synthetic table column id for row action icons (always rendered last when visible). */
export const TABLE_ACTIONS_COLUMN_ID = "__actions__";

/**
 * Ensures at most one actions column id and that it is last. Use when `includeActionsColumn` is true
 * after stripping duplicates from `orderedVisibleColumnIds`.
 */
export function orderedVisibleColumnIdsWithActionsLast(
    orderedVisibleColumnIds: Array<string>,
    includeActionsColumn: boolean,
): Array<string> {
    const withoutActions = orderedVisibleColumnIds.filter((id) => id !== TABLE_ACTIONS_COLUMN_ID);
    if (includeActionsColumn) {
        return [...withoutActions, TABLE_ACTIONS_COLUMN_ID];
    }
    return withoutActions;
}

export type TableColumnConfig = {
    revisionId: Uuid;
    /** Ordered list of visible column IDs */
    orderedVisibleColumnIds: Array<string>;
    /** Column IDs pinned to the left (max 3) */
    pinnedLeftColumnIds: Array<string>;
};

export type KanbanColumnConfig = {
    revisionId: Uuid;
    /** Ordered list of kanban column IDs (ordered by user preference) */
    orderedColumnIds: Array<Uuid>;
    /** The IDs of columns that are hidden (not visible) */
    hiddenColumnIds: Array<Uuid>;
    /** The kanban column ID pinned as focus (max 1) */
    pinnedColumnId: Uuid | null;
};
